
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.a1159378864 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a1777141296 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a1977051300 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b1282779605 = numberParserFn([{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.a1304576484 = pluralGeneratorFn(function(n
) {
  return 'other';
});
Globalize.a179475534 = messageFormatterFn((function(  ) {
  return function(d) { return "Log Masuk"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a354268604 = messageFormatterFn((function(  ) {
  return function(d) { return "Log masuk"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1941594449 = messageFormatterFn((function(  ) {
  return function(d) { return "Alamat e-mel"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a704441418 = messageFormatterFn((function(  ) {
  return function(d) { return "Kata Laluan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a852859625 = messageFormatterFn((function(  ) {
  return function(d) { return "Ini merupakan peranti awam atau berkongsi"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a218770210 = messageFormatterFn((function(  ) {
  return function(d) { return "Bukan peranti anda? Tindakan memilih kotak semakan ini mengurangkan jumlah masa anda dilog masuk di sini."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a2146006589 = messageFormatterFn((function(  ) {
  return function(d) { return "Kekalkan log masuk saya"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a808577695 = messageFormatterFn((function(  ) {
  return function(d) { return "Memilih kotak semakan ini akan mengekalkan log masuk ke dalam akaun anda pada peranti ini sehingga anda log keluar. Jangan guna pilihan ini pada peranti berkongsi."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1004020839 = messageFormatterFn((function(  ) {
  return function(d) { return "Lupa kata laluan?"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1790471594 = messageFormatterFn((function(  ) {
  return function(d) { return "Teruskan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1195558057 = messageFormatterFn((function(  ) {
  return function(d) { return "Batal"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1070749632 = messageFormatterFn((function(  ) {
  return function(d) { return "Kembali"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b448636478 = messageFormatterFn((function(  ) {
  return function(d) { return "Muat semula"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1540031993 = messageFormatterFn((function(  ) {
  return function(d) { return "Dengan mendaftar masuk, saya bersetuju dengan <a href=" + d["1"] + " " + d["3"] + ">Terma dan Syarat</a> dan <a href=" + d["2"] + " " + d["4"] + ">Kenyataan Privasi</a>" + d["0"] + "."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1318413893 = messageFormatterFn((function(  ) {
  return function(d) { return "Dengan mendaftar masuk, saya bersetuju dengan <a href=" + d["1"] + " " + d["5"] + ">Terma dan Syarat</a>, <a href=" + d["2"] + " " + d["6"] + ">Kenyataan Privasi</a> " + d["0"] + " serta <a href=" + d["3"] + " " + d["7"] + ">Terma dan Syarat " + d["4"] + "</a>."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1657537603 = messageFormatterFn((function(  ) {
  return function(d) { return "Dengan melog masuk, saya turut menyertai " + d["4"] + ". Saya bersetuju dengan <a href=" + d["1"] + " " + d["5"] + ">Terma dan Syarat</a> dan <a href=" + d["2"] + " " + d["6"] + ">Kenyataan Privasi</a> " + d["0"] + " serta <a href=" + d["3"] + " " + d["7"] + ">Terma dan Syarat " + d["4"] + "</a>."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1760728302 = messageFormatterFn((function(  ) {
  return function(d) { return "Akaun anda telah dijeda semasa pemeriksaan keselamatan rutin. Maklumat anda selamat, tetapi penetapan semula kata laluan diperlukan. Gunakan pautan \"Lupa kata laluan?\" di bawah untuk membuat perubahan bagi log masuk."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a834701592 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mel dan kata laluan tidak sepadan. Sila cuba lagi."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1767340483 = messageFormatterFn((function(  ) {
  return function(d) { return "Maaf, sesuatu yang tidak kena berlaku di pihak kami."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b992723447 = messageFormatterFn((function(  ) {
  return function(d) { return "Maaf, sesuatu yang tidak kena berlaku di pihak kami. Sila tunggu sebentar dan cuba lagi."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b230610393 = messageFormatterFn((function(  ) {
  return function(d) { return "Sila masukkan alamat e-mel anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1906670008 = messageFormatterFn((function(  ) {
  return function(d) { return "Masukkan e-mel yang sah."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1137355970 = messageFormatterFn((function(  ) {
  return function(d) { return "Sila masukkan kata laluan anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1064841876 = messageFormatterFn((function(  ) {
  return function(d) { return "Menyemak perakuan diri ID log masuk"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b288516263 = messageFormatterFn((function(  ) {
  return function(d) { return "Sembunyikan kata laluan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a25825876 = messageFormatterFn((function(  ) {
  return function(d) { return "Tunjukkan kata laluan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1860646506 = messageFormatterFn((function(  ) {
  return function(d) { return "Tidak mempunyai akaun? <span><a id=\"createAcctRedirectLink\" href=" + d["0"] + ">Daftar sekarang</a></span>"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a813966767 = messageFormatterFn((function(  ) {
  return function(d) { return "Log masuk"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1130696666 = messageFormatterFn((function(  ) {
  return function(d) { return "Log masuk melalui " + d["0"] + " bukan lagi pilihan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b894634178 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda boleh menggunakan e-mel yang sama untuk mengakses akaun " + d["0"] + " anda dengan penetapan semula kata laluan. Tindakan ini tidak akan memberi kesan kepada akaun " + d["1"] + " anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1418808596 = messageFormatterFn((function(  ) {
  return function(d) { return "Tetapkan semula kata laluan anda menggunakan butang di bawah. Gunakan e-mel dan kata laluan baharu anda untuk log masuk terus ke " + d["0"] + " pada kali seterusnya."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1331173349 = messageFormatterFn((function(  ) {
  return function(d) { return "Log masuk SSO"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a368806509 = messageFormatterFn((function(  ) {
  return function(d) { return "Log masuk menggunakan log masuk tunggal"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a929079079 = messageFormatterFn((function(  ) {
  return function(d) { return "Atau gunakan akaun " + d["0"] + " anda"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1817779878 = messageFormatterFn((function(  ) {
  return function(d) { return "Peroleh mata untuk mendapatkan perjalanan percuma. Jimat dengan harga ahli. Akses jadual perjalanan anda dengan mudah."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b898745228 = messageFormatterFn((function(  ) {
  return function(d) { return "Peroleh " + d["0"] + " mata Expedia Rewards selepas perjalanan ini."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1516344209 = messageFormatterFn((function(  ) {
  return function(d) { return "Log Masuk Akaun " + d["0"]; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b717186097 = messageFormatterFn((function(  ) {
  return function(d) { return "Lupa Kata Laluan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b2029729464 = messageFormatterFn((function(  ) {
  return function(d) { return "Tetapkan semula kata laluan anda"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1289814878 = messageFormatterFn((function(  ) {
  return function(d) { return "Masukkan e-mel anda dan kami akan menghantar pautan kepada anda untuk menetapkan semula kata laluan anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b2133852338 = messageFormatterFn((function(  ) {
  return function(d) { return "Hantar pautan tetap semula"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1101936427 = messageFormatterFn((function(  ) {
  return function(d) { return "Semak peti masuk anda"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1664573309 = messageFormatterFn((function(  ) {
  return function(d) { return "Kami telah menghantar e-mel kepada " + d["0"] + " yang menyertakan pautan untuk menetapkan semula kata laluan anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1664574270 = messageFormatterFn((function(  ) {
  return function(d) { return "Ia mungkin mengambil masa beberapa minit untuk menerima e-mel tersebut. Jika anda tidak melihat apa-apa selepas 10 minit, semak folder sarap atau spam anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1063615464 = messageFormatterFn((function(  ) {
  return function(d) { return "Hantar semula pautan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1392388064 = messageFormatterFn((function(  ) {
  return function(d) { return "Pautan baharu telah dihantar."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1646557779 = messageFormatterFn((function(  ) {
  return function(d) { return "Mengesahkan Akaun"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1038770029 = messageFormatterFn((function(  ) {
  return function(d) { return "Tetapkan Kata Laluan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1252522218 = messageFormatterFn((function(  ) {
  return function(d) { return "Kami gembira anda kembali"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b670754692 = messageFormatterFn((function(  ) {
  return function(d) { return "Hasilkan kata laluan unik untuk meneruskan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a566603385 = messageFormatterFn((function(  ) {
  return function(d) { return "Berjaya!"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a432774628 = messageFormatterFn((function(  ) {
  return function(d) { return "Kini sila gunakan kata laluan baharu untuk teruskan."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a44002017 = messageFormatterFn((function(  ) {
  return function(d) { return "Tetapkan semula kata laluan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1495229052 = messageFormatterFn((function(  ) {
  return function(d) { return "Harap maaf, permintaan ini telah tamat tempoh. Jika anda masih perlu mengubah kata laluan anda, sila klik di bawah untuk menghantar e-mel tetapkan semula kata laluan."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1188501132 = messageFormatterFn((function(  ) {
  return function(d) { return "Hantar semula pautan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a735522871 = messageFormatterFn((function(  ) {
  return function(d) { return "Menyimpan kata laluan anda"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1869738677 = messageFormatterFn((function(  ) {
  return function(d) { return "Daftar sekarang"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1094898409 = messageFormatterFn((function(  ) {
  return function(d) { return "Daftar sekarang"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1988341772 = messageFormatterFn((function(  ) {
  return function(d) { return "Alamat e-mel"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a322689644 = messageFormatterFn((function(  ) {
  return function(d) { return "Sila masukkan alamat e-mel anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a2052094269 = messageFormatterFn((function(  ) {
  return function(d) { return "Masukkan e-mel yang sah."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1404262637 = messageFormatterFn((function(  ) {
  return function(d) { return "Nama pertama"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b573426293 = messageFormatterFn((function(  ) {
  return function(d) { return "Sila masukkan nama pertama anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1226036629 = messageFormatterFn((function(  ) {
  return function(d) { return "Nama keluarga"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1614877453 = messageFormatterFn((function(  ) {
  return function(d) { return "Sila masukkan nama keluarga anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1891016428 = messageFormatterFn((function(  ) {
  return function(d) { return "Masukkan nama menggunakan huruf sahaja"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b375654171 = messageFormatterFn((function(  ) {
  return function(d) { return "Kata Laluan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b764494995 = messageFormatterFn((function(  ) {
  return function(d) { return "Sila masukkan kata laluan anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1795972860 = messageFormatterFn((function(  ) {
  return function(d) { return "Sila masukkan kata laluan yang sah."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b333755708 = messageFormatterFn((function(  ) {
  return function(d) { return "Sertakan 9-64 aksara"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b333754747 = messageFormatterFn((function(  ) {
  return function(d) { return "Gabungan huruf dan nombor"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b333753786 = messageFormatterFn((function(  ) {
  return function(d) { return "Satu aksara istimewa seperti ~ " + "#" + " @ $ % & ! * _ ? ^ -"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b333752825 = messageFormatterFn((function(  ) {
  return function(d) { return "Kata laluan tidak boleh mengandungi jarak"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1210567218 = messageFormatterFn((function(  ) {
  return function(d) { return "Kata laluan anda haruslah antara 8-64 aksara"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a372553183 = messageFormatterFn((function(  ) {
  return function(d) { return "Kata laluan tidak boleh sepadan dengan alamat e-mel anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a774885852 = messageFormatterFn((function(  ) {
  return function(d) { return "Kata laluan tidak boleh mengandungi jarak."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b9195756 = messageFormatterFn((function(  ) {
  return function(d) { return "Dengan mendaftar akaun, saya bersetuju dengan <a href=" + d["1"] + " " + d["3"] + ">Terma dan Syarat</a> dan <a href=" + d["2"] + " " + d["4"] + ">Kenyataan Privasi</a> " + d["0"] + "."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1388134862 = messageFormatterFn((function(  ) {
  return function(d) { return "Dengan mendaftar akaun, saya bersetuju dengan <a href=" + d["1"] + " " + d["5"] + ">Terma dan Syarat</a>, <a href=" + d["2"] + " " + d["6"] + ">Kenyataan Privasi</a> " + d["0"] + " serta <a href=" + d["3"] + " " + d["7"] + ">Terma dan Syarat " + d["4"] + "</a>."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b62707857 = messageFormatterFn((function(  ) {
  return function(d) { return "Saya ingin menerima tawaran perjalanan, tawaran istimewa dan maklumat lain daripada " + d["0"] + " menerusi e-mel."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b470136992 = messageFormatterFn((function(  ) {
  return function(d) { return "Saya ingin menerima tawaran perjalanan, tawaran istimewa dan maklumat lain daripada " + d["0"] + " menerusi e-mel. Anda boleh berhenti menerima e-mel promosi pada bila-bila masa."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1120543758 = messageFormatterFn((function(  ) {
  return function(d) { return "Saya ingin menerima idea percutian, tawaran istimewa dan maklumat lain daripada " + d["0"] + " menerusi e-mel."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1116356541 = messageFormatterFn((function(  ) {
  return function(d) { return "Saya ingin menerima idea percutian, tawaran istimewa dan maklumat lain daripada " + d["0"] + " menerusi e-mel. Anda boleh berhenti menerima e-mel promosi pada bila-bila masa."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1424400113 = messageFormatterFn((function(  ) {
  return function(d) { return "Teruskan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a2023178434 = messageFormatterFn((function(  ) {
  return function(d) { return "Sudah mempunyai akaun? <span><a id=\"signinRedirectLink\" href=" + d["0"] + ">Log masuk</a></span>"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1014399355 = messageFormatterFn((function(  ) {
  return function(d) { return "Selamat datang, " + d["0"]; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b2041743125 = messageFormatterFn((function(  ) {
  return function(d) { return "Dengan akaun " + d["0"] + " baharu anda, anda dapat ke mana-mana sahaja di seluruh dunia."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1814281076 = messageFormatterFn((function(  ) {
  return function(d) { return "Teruskan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1991280803 = messageFormatterFn((function(  ) {
  return function(d) { return "Kata laluan anda mestilah lebih kukuh untuk meneruskan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a754411042 = messageFormatterFn((function(  ) {
  return function(d) { return "Mestilah sekurang-kurangnya 8 aksara."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b511764410 = messageFormatterFn((function(  ) {
  return function(d) { return "Keberkesanan kata laluan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b390656708 = messageFormatterFn((function(  ) {
  return function(d) { return "Lemah"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a780069467 = messageFormatterFn((function(  ) {
  return function(d) { return "Kukuh"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a318585137 = messageFormatterFn((function(  ) {
  return function(d) { return "Sangat Kukuh"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1059113300 = messageFormatterFn((function(  ) {
  return function(d) { return "Elakkan daripada mengguna gantian huruf yang mudah diramal seperti '@' untuk 'a'."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1419011516 = messageFormatterFn((function(  ) {
  return function(d) { return "Elakkan daripada mengguna ejaan terbaik untuk perkataan lazim."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1468977476 = messageFormatterFn((function(  ) {
  return function(d) { return "Guna huruf besar pada beberapa huruf, namun bukan pada semua huruf."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1640603427 = messageFormatterFn((function(  ) {
  return function(d) { return "Guna huruf besar lebih daripada sekadar huruf pertama."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1971775583 = messageFormatterFn((function(  ) {
  return function(d) { return "Elakkan daripada mengguna tarikh dan tahun yang berkaitan dengan anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b2046745771 = messageFormatterFn((function(  ) {
  return function(d) { return "Elakkan daripada mengguna tahun terbaru."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b768126608 = messageFormatterFn((function(  ) {
  return function(d) { return "Elakkan daripada mengguna tahun yang berkaitan dengan anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1657416957 = messageFormatterFn((function(  ) {
  return function(d) { return "Elakkan daripada mengguna susun atur aksara yang lazim."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1234886505 = messageFormatterFn((function(  ) {
  return function(d) { return "Elakkan daripada mengguna perkataan dan aksara berulang."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a836389563 = messageFormatterFn((function(  ) {
  return function(d) { return "Gunakan kata laluan yang lebih unik dan ubah arah menaip berbilang kali."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b574350048 = messageFormatterFn((function(  ) {
  return function(d) { return "Tambah lebih banyak perkataan yang kurang lazim."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1207958644 = messageFormatterFn((function(  ) {
  return function(d) { return "Gunakan berbilang perkataan, namun elakkan frasa yang lazim."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1751044079 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda boleh menghasilkan kata laluan yang kukuh tanpa menggunakan simbol, nombor atau huruf besar."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a905246262 = messageFormatterFn((function(  ) {
  return function(d) { return "Alamat e-mel ini sudah pun dikaitkan dengan sebuah akaun di " + d["0"]; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b542545576 = messageFormatterFn((function(  ) {
  return function(d) { return "Kami telah hantarkan e-mel berserta pautan untuk melengkapkan pendaftaran akaun anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1246303367 = messageFormatterFn((function(  ) {
  return function(d) { return "Permintaan pendaftaran sedang berjalan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a106241395 = messageFormatterFn((function(  ) {
  return function(d) { return "Nama pertama mestilah sepanjang minimum dua aksara"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b16346341 = messageFormatterFn((function(  ) {
  return function(d) { return "Nama akhir mestilah sepanjang minimum dua aksara"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1354291233 = messageFormatterFn((function(  ) {
  return function(d) { return "Nama pertama boleh mempunyai panjang maksimum 100 aksara"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1231703497 = messageFormatterFn((function(  ) {
  return function(d) { return "Nama keluarga boleh mempunyai panjang maksimum 100 aksara"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a520493788 = messageFormatterFn((function(  ) {
  return function(d) { return "Nama pertama tidak boleh mengandungi aksara khas"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1322203516 = messageFormatterFn((function(  ) {
  return function(d) { return "Nama keluarga tidak boleh mengandungi aksara khas"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a994174522 = messageFormatterFn((function(  ) {
  return function(d) { return "Saya bersetuju dengan semua perkara di bawah"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1281394234 = messageFormatterFn((function(  ) {
  return function(d) { return "Saya mengesahkan bahawa saya berusia 18 tahun ke atas dan telah menyemak serta bersetuju dengan <a href=" + d["0"] + " " + d["1"] + ">Terma Penggunaan</a> serta <a href=" + d["2"] + " " + d["3"] + ">" + d["4"] + " Terma dan Syarat</a> (diperlukan)"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1040628932 = messageFormatterFn((function(  ) {
  return function(d) { return "Saya bersetuju terhadap pengumpulan dan penggunaan maklumat peribadi saya seperti yang diterangkan dalam <a href=" + d["0"] + " " + d["1"] + ">Dasar Privasi</a> (diperlukan)"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b201936111 = messageFormatterFn((function(  ) {
  return function(d) { return "Saya bersetuju terhadap peruntukan maklumat peribadi saya kepada pihak ketiga, sama ada di Korea atau luar negara, seperti yang diterangkan dalam <a href=" + d["0"] + " " + d["1"] + ">Dasar Privasi</a> (diperlukan)"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b421608370 = messageFormatterFn((function(  ) {
  return function(d) { return "Sila terima terma untuk meneruskan."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a792812874 = messageFormatterFn((function(  ) {
  return function(d) { return "Terima Terma untuk meneruskan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b904561210 = messageFormatterFn((function(  ) {
  return function(d) { return "Tandakan kotak untuk meneruskan proses"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b2087386177 = messageFormatterFn((function(  ) {
  return function(d) { return "Atau daftar akaun dengan " + d["0"]; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a822721951 = messageFormatterFn((function(  ) {
  return function(d) { return "Elakkan penggunaan jarak, nama anda, e-mel atau kata laluan yang pernah anda gunakan sebelum ini."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b730789475 = messageFormatterFn((function(  ) {
  return function(d) { return "Maaf, sesuatu yang tidak kena berlaku pada pihak kami. Sila tunggu beberapa minit, kemudian cuba lagi."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1960618813 = messageFormatterFn((function(  ) {
  return function(d) { return "Sahkan nombor mudah alih anda"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1038745356 = messageFormatterFn((function(  ) {
  return function(d) { return "Kami akan menghantar kod pengesahan sekali kepada nombor mudah alih anda bagi memastikan akaun anda kekal selamat."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a430432627 = messageFormatterFn((function(  ) {
  return function(d) { return "Hantar"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1690906420 = messageFormatterFn((function(  ) {
  return function(d) { return "© " + d["1"] + " " + d["0"] + " Hak cipta terpelihara."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a211524226 = messageFormatterFn((function(  ) {
  return function(d) { return "Terma dan Syarat"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a2078304323 = messageFormatterFn((function(  ) {
  return function(d) { return "Dasar Privasi"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1797140634 = messageFormatterFn((function(  ) {
  return function(d) { return "Hantar mesej"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1669656465 = messageFormatterFn((function(  ) {
  return function(d) { return "Masukkan kod pengesahan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a216068769 = messageFormatterFn((function(  ) {
  return function(d) { return "Kod pengesahan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1405083668 = messageFormatterFn((function(  ) {
  return function(d) { return "Hantar semula kod"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b2141042057 = messageFormatterFn((function(  ) {
  return function(d) { return "Ubah nombor mudah alih"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a157166621 = messageFormatterFn((function(  ) {
  return function(d) { return "Kod pengesahan telah dihantar semula."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1241407542 = messageFormatterFn((function(  ) {
  return function(d) { return "Masukkan kod pengesahan 6 digit yang kami baru hantar ke " + d["0"]; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1347780803 = messageFormatterFn((function(  ) {
  return function(d) { return "Menyemak kod pengesahan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a551176612 = messageFormatterFn((function(  ) {
  return function(d) { return "Kod ini tidak betul. Hantar semula kod untuk mencuba lagi."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a718945058 = messageFormatterFn((function(  ) {
  return function(d) { return "atau teruskan dengan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b37267150 = messageFormatterFn((function(  ) {
  return function(d) { return "Jimat " + d["0"] + "% secara purata pada beribu-ribu hotel sebagai ahli—keahlian sentiasa percuma."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1763770176 = messageFormatterFn((function(  ) {
  return function(d) { return "atau"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1257756482 = messageFormatterFn((function(  ) {
  return function(d) { return "Cara lain untuk log masuk"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1257397068 = messageFormatterFn((function(  ) {
  return function(d) { return "Cara lain untuk mendaftar"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b704422762 = messageFormatterFn((function(  ) {
  return function(d) { return "Daftar dengan Google"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1967688053 = messageFormatterFn((function(  ) {
  return function(d) { return "Log masuk tidak berjaya. Sila cuba semula atau daftar akaun di laman ini untuk meneruskan."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a811864815 = messageFormatterFn((function(  ) {
  return function(d) { return "Log masuk melalui nombor telefon tidak tersedia. Pastikan akaun sosial anda ditetapkan untuk berkongsi e-mel anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1470392807 = messageFormatterFn((function(  ) {
  return function(d) { return "Jimat " + d["0"] + "% atau lebih pada beribu-ribu hotel sebagai ahli—keahlian sentiasa percuma."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1256798412 = messageFormatterFn((function(  ) {
  return function(d) { return "Log masuk dengan akaun Google"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a448342079 = messageFormatterFn((function(  ) {
  return function(d) { return "Log masuk dengan NAVER"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1099968235 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda telah melebihi bilangan maksimum cubaan log masuk. Sila cuba lagi kemudian."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1292210626 = messageFormatterFn((function(  ) {
  return function(d) { return "Log masuk menggunakan biometrik anda"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b39384286 = messageFormatterFn((function(  ) {
  return function(d) { return "Gunakan biometrik untuk mengakses akaun anda supaya anda tidak perlu menaip kata laluan."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1233630735 = messageFormatterFn((function(  ) {
  return function(d) { return "Bermula"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1008435393 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingatkan kemudian"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1710501033 = messageFormatterFn((function(  ) {
  return function(d) { return "Berjaya!"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a820219313 = messageFormatterFn((function(  ) {
  return function(d) { return "Log masuk biometrik telah didayakan."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b760230375 = messageFormatterFn((function(  ) {
  return function(d) { return "Log masuk menggunakan biometrik"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1931250078 = messageFormatterFn((function(  ) {
  return function(d) { return "Gunakan kata laluan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b714115081 = messageFormatterFn((function(  ) {
  return function(d) { return "Gunakan biometrik"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1488106000 = messageFormatterFn((function(  ) {
  return function(d) { return "Kemas kini kata laluan anda untuk teruskan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a919596428 = messageFormatterFn((function(  ) {
  return function(d) { return "Untuk mengakses akaun anda, penetapan semula kata laluan diperlukan."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a21927294 = messageFormatterFn((function(  ) {
  return function(d) { return "Tetapkan semula kata laluan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b360445246 = messageFormatterFn((function(  ) {
  return function(d) { return "Selamat datang ke faedah ahli"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a732804200 = messageFormatterFn((function(  ) {
  return function(d) { return "Mulakan pengembaraan anda yang seterusnya dengan hadiah sebanyak $" + d["0"] + " dalam bentuk mata daripada kami!"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1665327560 = messageFormatterFn((function(  ) {
  return function(d) { return "Hadiah ini boleh terus dilihat dalam akaun anda dan digunakan pada tempahan pertama anda, anda hanya perlu mencari pilihan untuk menggunakan mata anda semasa semak keluar."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b100702602 = messageFormatterFn((function(  ) {
  return function(d) { return "Kini anda merupakan ahli Expedia."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1596420474 = messageFormatterFn((function(  ) {
  return function(d) { return "Segera berjimat dengan Harga Ahli dan dapatkan mata apabila anda membuat tempahan."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b832422801 = messageFormatterFn((function(  ) {
  return function(d) { return "Log masuk atau daftar akaun"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1313033205 = messageFormatterFn((function(  ) {
  return function(d) { return "Jimat " + d["0"] + "% secara purata pada beribu-ribu hotel sebagai ahli—keahlian sentiasa percuma."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a90023383 = messageFormatterFn((function(  ) {
  return function(d) { return "Dengan meneruskan, anda telah membaca dan bersetuju dengan <a href=" + d["1"] + " " + d["3"] + ">Terma dan Syarat</a> dan <a href=" + d["2"] + " " + d["4"] + ">Kenyataan Privasi</a> kami."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a455319531 = messageFormatterFn((function(  ) {
  return function(d) { return "Dengan meneruskan, anda telah membaca dan bersetuju dengan <a href=" + d["1"] + " " + d["5"] + ">Terma dan Syarat</a> dan <a href=" + d["2"] + " " + d["6"] + ">Kenyataan Privasi</a> kami serta <a href=" + d["3"] + " " + d["7"] + ">Terma & Syarat " + d["4"] + "</a>."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1234159162 = messageFormatterFn((function(  ) {
  return function(d) { return "Dengan meneruskan proses, anda telah membaca dan bersetuju dengan <a href=" + d["1"] + " " + d["4"] + ">Terma dan Syarat</a>, <a href=" + d["2"] + " " + d["5"] + ">Kenyataan Privasi</a> dan <a href=" + d["3"] + " " + d["6"] + ">Terma dan Syarat Ganjaran One Key</a> kami."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1485144610 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mel"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1913469592 = messageFormatterFn((function(  ) {
  return function(d) { return "Masukkan e-mel yang sah"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1839856101 = messageFormatterFn((function(  ) {
  return function(d) { return "Google"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b332757592 = messageFormatterFn((function(  ) {
  return function(d) { return "Facebook"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a879950542 = messageFormatterFn((function(  ) {
  return function(d) { return "Apple"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a831402777 = messageFormatterFn((function(  ) {
  return function(d) { return "Pilihan ini untuk peranti peribadi sahaja. Jangan tandakan kotak ini pada peranti berkongsi untuk memastikan akaun anda selamat."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1207498024 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda cuba log masuk terlalu banyak kali. Anda perlu menunggu " + d["0"] + " minit sebelum mencuba lagi."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1217879876 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda cuba log masuk terlalu banyak kali. Anda perlu menunggu " + d["0"] + " minit sebelum mencuba lagi."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1212984542 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda cuba log masuk terlalu banyak kali. Anda perlu menunggu " + d["0"] + " minit sebelum mencuba lagi."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1226442386 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda cuba log masuk terlalu banyak kali. Anda perlu menunggu " + d["0"] + " minit sebelum mencuba lagi."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a831515423 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda cuba log masuk terlalu banyak kali. Anda perlu menunggu " + d["0"] + " minit sebelum mencuba lagi."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1974893530 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda cuba log masuk terlalu banyak kali. Anda perlu menunggu " + d["0"] + " minit sebelum mencuba lagi."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a361026709 = messageFormatterFn((function(  ) {
  return function(d) { return "Nikmati dunia ganjaran dengan satu akaun di seluruh Expedia, Hotels.com dan Vrbo."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b159046141 = messageFormatterFn((function(  ) {
  return function(d) { return "Nikmati dunia pengembaraan dengan satu akaun di seluruh Expedia, Hotels.com dan Vrbo."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1377681526 = messageFormatterFn((function(  ) {
  return function(d) { return "Layari dan simpan hartanah, rancang dengan kumpulan anda dan akses butiran tempahan anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1808628873 = messageFormatterFn((function(  ) {
  return function(d) { return "Akaun anda telah dijeda semasa pemeriksaan keselamatan rutin. Maklumat anda selamat, tetapi penetapan semula kata laluan diperlukan."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b352969017 = messageFormatterFn((function(  ) {
  return function(d) { return "Log masuk dan tempah penginapan anda untuk memperoleh OneKeyCash"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a62933869 = messageFormatterFn((function(  ) {
  return function(d) { return "Mari kita sahkan bahawa itu adalah anda"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a510614605 = messageFormatterFn((function(  ) {
  return function(d) { return "Masukkan kod selamat yang kami hantar ke e-mel anda. Semak mel remeh jika e-mel tidak ada dalam peti masuk anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a338424319 = messageFormatterFn((function(  ) {
  return function(d) { return "Mari sahkan e-mel anda"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b35892101 = messageFormatterFn((function(  ) {
  return function(d) { return "Untuk meneruskan, masukkan kod keselamatan yang kami hantar kepada " + d["0"] + ". Semak mel remeh jika e-mel tidak ada dalam peti masuk anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b251108437 = messageFormatterFn((function(  ) {
  return function(d) { return "Kod 6 digit"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b2021792341 = messageFormatterFn((function(  ) {
  return function(d) { return "Hantar semula kod"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b685663294 = messageFormatterFn((function(  ) {
  return function(d) { return "(0:" + d["0"] + ")"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a909153622 = messageFormatterFn((function(  ) {
  return function(d) { return "Hantar semula kod dalam " + d["0"] + "s"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1015063590 = messageFormatterFn((function(  ) {
  return function(d) { return "Tidak menerima e-mel?"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a494188676 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda boleh meminta kod lain dalam " + d["0"]; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1923438373 = messageFormatterFn((function(  ) {
  return function(d) { return "Minta kod keselamatan lain"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1593933713 = messageFormatterFn((function(  ) {
  return function(d) { return "Kami telah menghantar kod 6 digit baharu ke peti masuk anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1577075462 = messageFormatterFn((function(  ) {
  return function(d) { return "Masukkan kata laluan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b64340985 = messageFormatterFn((function(  ) {
  return function(d) { return "Kod tidak sah, sila cuba lagi"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1172839627 = messageFormatterFn((function(  ) {
  return function(d) { return "Kod tamat tempoh, sila hantar semula dan cuba lagi"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a828361130 = messageFormatterFn((function(  ) {
  return function(d) { return "Periksa mel remeh jika e-mel tidak ada dalam peti masuk anda"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1074680977 = messageFormatterFn((function(  ) {
  return function(d) { return "Kami telah mengemas kini pengalaman kami dan perlu mengesahkan e-mel anda. Masukkan kod selamat yang kami hantar ke peti masuk anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b303815474 = messageFormatterFn((function(  ) {
  return function(d) { return "Sesuatu yang tidak kena berlaku di pihak kami. Sila cuba lagi."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1518802025 = messageFormatterFn((function(  ) {
  return function(d) { return "Untuk mengemas kini kaedah log masuk anda, masukkan kod selamat yang kami hantar ke e-mel anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1973471119 = messageFormatterFn((function(  ) {
  return function(d) { return "Masukkan kata laluan anda"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1953902280 = messageFormatterFn((function(  ) {
  return function(d) { return "Hantar kod selamat melalui e-mel"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b30907752 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mel dan kata laluan tidak sepadan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1426348897 = messageFormatterFn((function(  ) {
  return function(d) { return "Cipta kata laluan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1740699381 = messageFormatterFn((function(  ) {
  return function(d) { return "Cipta kata laluan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1486663185 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda boleh menggunakan e-mel dan kata laluan yang sama untuk log masuk ke Expedia, Hotels.com dan Vrbo."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a703230161 = messageFormatterFn((function(  ) {
  return function(d) { return "Cipta kata laluan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a572639724 = messageFormatterFn((function(  ) {
  return function(d) { return "Tetapkan kata laluan untuk digunakan selain kaedah log masuk selamat lain."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b601749471 = messageFormatterFn((function(  ) {
  return function(d) { return "Tetapkan kata laluan baharu"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b828078645 = messageFormatterFn((function(  ) {
  return function(d) { return "Tetapkan kata laluan baharu"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b745300689 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda kini boleh menggunakan satu akaun untuk mendaftar masuk ke Expedia, Hotels.com dan Vrbo. Cipta kata laluan baharu yang selamat untuk akaun gabungan anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1911512465 = messageFormatterFn((function(  ) {
  return function(d) { return "Cipta kata laluan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1304325961 = messageFormatterFn((function(  ) {
  return function(d) { return "Tukar kata laluan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a199230041 = messageFormatterFn((function(  ) {
  return function(d) { return "Gunakan kata laluan yang unik dan kukuh."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b199233497 = messageFormatterFn((function(  ) {
  return function(d) { return "Kemas kini kata laluan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1328680684 = messageFormatterFn((function(  ) {
  return function(d) { return "Kami tidak dapat menukar kata laluan anda. Sila cuba lagi."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1718552114 = messageFormatterFn((function(  ) {
  return function(d) { return "Lupa kata laluan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b370675864 = messageFormatterFn((function(  ) {
  return function(d) { return "Masukkan e-mel anda dan kami akan menghantar kod selamat kepada anda untuk log masuk."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b260328264 = messageFormatterFn((function(  ) {
  return function(d) { return "Hantarkan e-mel"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a725857540 = messageFormatterFn((function(  ) {
  return function(d) { return "Hubungi kami"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1604749931 = messageFormatterFn((function(  ) {
  return function(d) { return "Padamkan data"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1730172448 = messageFormatterFn((function(  ) {
  return function(d) { return "Tutup"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1155076868 = messageFormatterFn((function(  ) {
  return function(d) { return "Sila tunggu sementara kami menyemak akaun anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1794257851 = messageFormatterFn((function(  ) {
  return function(d) { return "Padamkan akaun"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b651105505 = messageFormatterFn((function(  ) {
  return function(d) { return "Ok, saya faham"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b2105342139 = messageFormatterFn((function(  ) {
  return function(d) { return "Maaf, anda tidak boleh memadamkan akaun sehingga perjalanan anda selesai."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1425948838 = messageFormatterFn((function(  ) {
  return function(d) { return "Untuk memastikan perjalanan yang lancar, anda memerlukan akaun untuk mengakses tempahan anda dan mendapatkan bantuan daripada perkhidmatan pelanggan kami sekiranya berlaku perubahan saat akhir."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1102761901 = messageFormatterFn((function(  ) {
  return function(d) { return "Maaf, anda perlu memadamkan akaun pemilik Vrbo anda terlebih dahulu"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a221801706 = messageFormatterFn((function(  ) {
  return function(d) { return "Sila layari pusat Bantuan kami di laman web atau pada apl untuk menghubungi perkhidmatan pelanggan kami secara langsung untuk memulakan proses."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b446344166 = messageFormatterFn((function(  ) {
  return function(d) { return "Sila cuba lagi selepas perjalanan anda tamat."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b2109959113 = messageFormatterFn((function(  ) {
  return function(d) { return "Beritahu kami sebab peninggalan anda"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b2127599240 = messageFormatterFn((function(  ) {
  return function(d) { return "Saya mendapat terlalu banyak e-mel atau pemberitahuan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1599906062 = messageFormatterFn((function(  ) {
  return function(d) { return "Saya mempunyai akaun " + d["0"] + " yang lain"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a650015177 = messageFormatterFn((function(  ) {
  return function(d) { return "Perjalanan saya sudah tamat, jadi saya tidak memerlukan akaun ini"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a625569487 = messageFormatterFn((function(  ) {
  return function(d) { return "Saya mempunyai pengalaman negatif membuat tempahan dengan " + d["0"]; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1605517136 = messageFormatterFn((function(  ) {
  return function(d) { return "Lain-lain"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b351454707 = messageFormatterFn((function(  ) {
  return function(d) { return "Langkau"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b509858988 = messageFormatterFn((function(  ) {
  return function(d) { return "Serah"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b989137052 = messageFormatterFn((function(  ) {
  return function(d) { return "Kami kesal melihat anda pergi. Berikut merupakan beberapa butiran yang perlu anda tahu:"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1453679785 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan hilang " + d["0"] + " mata Expedia Rewards bernilai " + d["1"] + ", kredit bernilai " + d["2"] + ", kupon, item perjalanan yang disimpan dan pilihan akaun selama-lamanya."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1184588008 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan hilang " + d["0"] + " mata Expedia Rewards bernilai " + d["1"] + ", kupon, item perjalanan yang disimpan dan pilihan akaun selama-lamanya."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a926278890 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan hilang kemasukan, kredit dan pilihan perjalanan anda selama-lamanya."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a312047392 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards: Anda akan hilang " + d["0"] + " malam reward bernilai " + d["1"] + " dan " + d["2"] + " cap bernilai purata " + d["3"] + "."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1988634289 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan hilang kredit, kupon, item perjalanan yang disimpan dan pilihan akaun selama-lamanya."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a384126553 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan hilang " + d["0"] + " CheapCash bernilai " + d["1"] + ", kredit bernilai " + d["2"] + ", kupon, item perjalanan yang disimpan dan pilihan akaun selama-lamanya."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a849447224 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan hilang " + d["0"] + " CheapCash bernilai " + d["1"] + ", kupon, item perjalanan yang disimpan dan pilihan akaun selama-lamanya."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1777943313 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan hilang " + d["0"] + " Orbucks bernilai " + d["1"] + ", kredit bernilai " + d["2"] + ", kupon, item perjalanan yang disimpan dan pilihan akaun selama-lamanya."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a519827840 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan hilang " + d["0"] + " Orbucks bernilai " + d["1"] + ", kupon, item perjalanan yang disimpan dan pilihan akaun selama-lamanya."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b740556695 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan hilang " + d["0"] + " MrJet Rewards bernilai " + d["1"] + ", kredit bernilai " + d["2"] + ", kupon, item perjalanan yang disimpan dan pilihan akaun selama-lamanya."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b536744664 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan hilang " + d["0"] + " MrJet Rewards bernilai " + d["1"] + ", kupon, item perjalanan yang disimpan dan pilihan akaun selama-lamanya."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1963277305 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan hilang " + d["0"] + " BONUS+ bernilai " + d["1"] + ", kredit bernilai " + d["2"] + ", kupon, item perjalanan yang disimpan dan pilihan akaun selama-lamanya."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1614993304 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan hilang " + d["0"] + " BONUS+ bernilai " + d["1"] + ", kupon, item perjalanan yang disimpan dan pilihan akaun selama-lamanya."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b283567485 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan hilang kupon, item perjalanan yang disimpan dan pilihan akaun selama-lamanya."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b6253352 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan hilang kredit bernilai " + d["0"] + ", kupon, item perjalanan yang disimpan dan pilihan akaun selama-lamanya."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1193164706 = messageFormatterFn((function(  ) {
  return function(d) { return "Kami mungkin menyimpan sesetengah maklumat, seperti rekod transaksi anda untuk memenuhi kewajipan undang-undang atau sekiranya kami perlu membuat, mengamalkan atau mempertahankan tuntutan undang-undang. Maklumat ini akan disimpan dengan selamat dan akan dipadam, dinyahnamakan atau dikaburkan secara kekal sebaik sahaja maklumat tidak lagi diperlukan."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b229686706 = messageFormatterFn((function(  ) {
  return function(d) { return "Padamkan akaun secara kekal"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a267743650 = messageFormatterFn((function(  ) {
  return function(d) { return "Jangan padamkan akaun"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1533886696 = messageFormatterFn((function(  ) {
  return function(d) { return "Kami berharap dapat bertemu anda lagi"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a838815673 = messageFormatterFn((function(  ) {
  return function(d) { return "Permintaan pemadaman anda mungkin mengambil masa beberapa minggu untuk diproses, jadi anda mungkin akan terus menerima komunikasi semasa sistem kami dikemas kini."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1861036051 = messageFormatterFn((function(  ) {
  return function(d) { return "Sila cuba lagi"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1373467026 = messageFormatterFn((function(  ) {
  return function(d) { return "Ralat sistem berlaku. Serahkan semula pemadaman akaun anda atau cuba lagi dalam masa beberapa minit."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a521760310 = messageFormatterFn((function(  ) {
  return function(d) { return "Tutup"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a272454031 = messageFormatterFn((function(  ) {
  return function(d) { return "Apakah nama yang anda gunakan pada ID perjalanan anda?"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1802571039 = messageFormatterFn((function(  ) {
  return function(d) { return "Padankan nama akaun anda dengan ID yang anda gunakan semasa mengembara, seperti pasport atau lesen. Kami akan memastikan semuanya tersedia pada kali seterusnya anda membuat tempahan."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1256418255 = messageFormatterFn((function(  ) {
  return function(d) { return "Terima tawaran dan maklumat lain daripada " + d["0"] + " melalui e-mel."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b166453504 = messageFormatterFn((function(  ) {
  return function(d) { return "Terima tawaran dan maklumat lain daripada " + d["0"] + " melalui e-mel. Anda boleh memilih untuk berhenti menerima e-mel pemasaran pada bila-bila masa."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b233962821 = messageFormatterFn((function(  ) {
  return function(d) { return "Maklumat Akaun"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a627947345 = messageFormatterFn((function(  ) {
  return function(d) { return "Dapatkan e-mel tentang tawaran, promosi dan maklumat lain daripada " + d["0"] + ". Anda boleh menarik diri pada bila-bila masa."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1542636141 = messageFormatterFn((function(  ) {
  return function(d) { return "Kekal maklum"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1115002969 = messageFormatterFn((function(  ) {
  return function(d) { return "Persetujuan Pemasaran"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a900812648 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia Rewards"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a2057913082 = messageFormatterFn((function(  ) {
  return function(d) { return "CheapCash"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1703574414 = messageFormatterFn((function(  ) {
  return function(d) { return "Orbitz Rewards"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a2004265242 = messageFormatterFn((function(  ) {
  return function(d) { return "BONUS+"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1779535592 = messageFormatterFn((function(  ) {
  return function(d) { return "MrJet"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1125496961 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1312029675 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a975410584 = messageFormatterFn((function(  ) {
  return function(d) { return "Maaf, anda perlu menunggu sehingga perjalanan anda selesai"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1826013240 = messageFormatterFn((function(  ) {
  return function(d) { return "Maaf, anda perlu menunggu sehingga perjalanan akan datang anda"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1248041214 = messageFormatterFn((function(  ) {
  return function(d) { return "Akaun anda membolehkan anda mengakses butiran tempahan dan sokongan jika perlu. Sila cuba lagi selepas perjalanan anda tamat."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a137324962 = messageFormatterFn((function(  ) {
  return function(d) { return "Akaun anda membolehkan anda mengakses butiran tempahan dan sokongan jika perlu. Sila cuba lagi selepas perjalanan anda tamat."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a170195995 = messageFormatterFn((function(  ) {
  return function(d) { return "Maaf, akaun anda tidak boleh dipadamkan pada masa ini"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a513787781 = messageFormatterFn((function(  ) {
  return function(d) { return "Akaun ini juga digunakan untuk mengehos hartanah di Vrbo. Sebelum anda boleh memadamkan akaun, anda perlu log masuk dengan aplikasi atau laman web Pemilik Vrbo untuk mengeluarkan penyenaraian aktif anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1255660278 = messageFormatterFn((function(  ) {
  return function(d) { return "Sila beritahu kami sebab anda meninggalkan kami."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1919612065 = messageFormatterFn((function(  ) {
  return function(d) { return "Saya mempunyai akaun dengan e-mel lain"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1448914338 = messageFormatterFn((function(  ) {
  return function(d) { return "Saya mempunyai pengalaman negatif semasa membuat tempahan"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a2061021815 = messageFormatterFn((function(  ) {
  return function(d) { return "Kami kesal melihat anda pergi. Harap maklum bahawa pemadaman akaun anda tidak boleh dibuat asal dan akan menjejaskan data anda dengan Expedia, Hotels.com dan Vrbo. Berikut merupakan beberapa butiran yang perlu anda tahu:"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1493258750 = messageFormatterFn((function(  ) {
  return function(d) { return "Kami kesal melihat anda pergi. Harap maklum bahawa pemadaman akaun anda tidak boleh dibuat asal dan akan menjejaskan data anda dengan Expedia, Wotif, Hotels.com dan Vrbo. Berikut merupakan beberapa butiran yang perlu anda tahu:"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a775888485 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan kehilangan sejarah akaun, keutamaan dan item yang disimpan merentas Expedia, Hotels.com dan Vrbo."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a515108720 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan kehilangan sejarah akaun anda, keutamaan dan item yang disimpan merentas Expedia, Wotif, Hotels.com dan Vrbo secara kekal."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1232832551 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan kehilangan semua OneKeyCash, termasuk mana-mana OneKeyCash yang menunggu kelulusan dan tingkat One Key anda serta semua faedah One Key secara kekal."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1389470641 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan kehilangan mana-mana OneKeyCash yang menunggu kelulusan dan tingkat One Key anda serta semua faedah One Key secara kekal."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1059709308 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan kehilangan " + d["0"] + " dalam bentuk OneKeyCash, mana-mana OneKeyCash yang menunggu kelulusan dan tingkat One Key anda serta semua faedah One Key secara kekal."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b283411494 = messageFormatterFn((function(  ) {
  return function(d) { return "Pemegang kad kredit Hotels.com Rewards akan tidak lagi menerima ganjaran berdasarkan aktiviti kad."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a872415287 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan kehilangan semua mata Expedia Rewards, termasuk semua mata Expedia Rewards yang disahkan atau menunggu kelulusan, cap dan malam reward Hotels.com Rewards serta tingkat ganjaran anda secara kekal."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1100396973 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan kehilangan mana-mana mata Expedia Rewards dan cap serta malam ganjaran Hotels.com Rewards dan tingkat ganjaran anda secara kekal."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a879048499 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan kehilangan semua kupon dan kredit untuk Expedia, Hotels.com atau Vrbo secara kekal."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1758743106 = messageFormatterFn((function(  ) {
  return function(d) { return "Anda akan kehilangan semua kupon dan kredit untuk Expedia, Wotif, Hotels.com atau Vrbo secara kekal."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a362592012 = messageFormatterFn((function(  ) {
  return function(d) { return "Permintaan pemadaman akaun anda untuk Expedia, Hotels.com dan Vrbo boleh mengambil masa beberapa minggu untuk diproses, jadi anda boleh terus menerima komunikasi semasa sistem kami dikemas kini."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b2119160105 = messageFormatterFn((function(  ) {
  return function(d) { return "Permintaan pemadaman akaun anda untuk Expedia, Wotif, Hotels.com dan Vrbo boleh mengambil masa beberapa minggu untuk diproses, jadi anda boleh terus menerima komunikasi semasa sistem kami mengemaskinikan permintaan itu."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b821153279 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key Card anda akan ditutup apabila anda memadam akaun anda dan anda tidak akan lagi memperoleh OneKeyCash pada mana-mana pembelian. Wells Fargo akan menghubungi anda tentang pengesahan penutupan kad anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1871220023 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key+ Card anda akan ditutup apabila anda memadam akaun anda dan anda tidak akan lagi memperoleh OneKeyCash pada mana-mana pembelian. Wells Fargo akan menghubungi anda tentang pengesahan penutupan kad anda."; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a713412610 = messageFormatterFn((function(  ) {
  return function(d) { return "Log masuk atau cipta akaun untuk memperoleh OneKeyCash untuk perjalanan anda"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a2020096536 = messageFormatterFn((function(  ) {
  return function(d) { return "Log masuk atau cipta akaun untuk memperoleh ganjaran untuk penginapan ini"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b2117880831 = messageFormatterFn((function(  ) {
  return function(d) { return "Daftar keluar sebagai tetamu"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a739953325 = messageFormatterFn((function(  ) {
  return function(d) { return "Log Masuk Akaun " + d["0"] + ": Tambah Nombor Telefon Mudah Alih"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b1298181405 = messageFormatterFn((function(  ) {
  return function(d) { return "Sesuatu yang tidak kena telah berlaku"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.b564769149 = messageFormatterFn((function(  ) {
  return function(d) { return "Cuba log masuk semula"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1184956026 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("ms-MY").pluralGenerator({}));
Globalize.a1656134910 = dateToPartsFormatterFn({"2":Globalize("ms-MY").numberFormatter({"raw":"00"}),"4":Globalize("ms-MY").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.a541588542 = dateToPartsFormatterFn({"2":Globalize("ms-MY").numberFormatter({"raw":"00"}),"4":Globalize("ms-MY").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.a75292689 = dateToPartsFormatterFn({"1":Globalize("ms-MY").numberFormatter({"raw":"0"}),"4":Globalize("ms-MY").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.b1047161269 = dateToPartsFormatterFn({"1":Globalize("ms-MY").numberFormatter({"raw":"0"}),"4":Globalize("ms-MY").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.a595729566 = dateToPartsFormatterFn({"2":Globalize("ms-MY").numberFormatter({"raw":"00"}),"4":Globalize("ms-MY").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.b1471004141 = dateToPartsFormatterFn({"1":Globalize("ms-MY").numberFormatter({"raw":"0"}),"4":Globalize("ms-MY").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.b1901515714 = dateToPartsFormatterFn({"2":Globalize("ms-MY").numberFormatter({"raw":"00"}),"4":Globalize("ms-MY").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.a649870590 = dateToPartsFormatterFn({"2":Globalize("ms-MY").numberFormatter({"raw":"00"}),"4":Globalize("ms-MY").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.a1179364862 = dateToPartsFormatterFn({"2":Globalize("ms-MY").numberFormatter({"raw":"00"}),"4":Globalize("ms-MY").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b166278703 = dateToPartsFormatterFn({"1":Globalize("ms-MY").numberFormatter({"raw":"0"}),"4":Globalize("ms-MY").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.b122690402 = dateToPartsFormatterFn({"2":Globalize("ms-MY").numberFormatter({"raw":"00"}),"4":Globalize("ms-MY").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b443618143 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"A","mon":"I","tue":"S","wed":"R","thu":"K","fri":"J","sat":"S"}}}});
Globalize.a1786774206 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"Ahad","mon":"Isnin","tue":"Selasa","wed":"Rabu","thu":"Khamis","fri":"Jumaat","sat":"Sabtu"}}}});
Globalize.a533528766 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"Januari","2":"Februari","3":"Mac","4":"April","5":"Mei","6":"Jun","7":"Julai","8":"Ogos","9":"September","10":"Oktober","11":"November","12":"Disember"}}}});
Globalize.a1990208738 = dateToPartsFormatterFn({"1":Globalize("ms-MY").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.b965618511 = dateToPartsFormatterFn({"1":Globalize("ms-MY").numberFormatter({"raw":"0"}),"2":Globalize("ms-MY").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.b2034263952 = dateToPartsFormatterFn({"1":Globalize("ms-MY").numberFormatter({"raw":"0"})}, {"pattern":"d MMM","timeSeparator":":","months":{"M":{"3":{"1":"Jan","2":"Feb","3":"Mac","4":"Apr","5":"Mei","6":"Jun","7":"Jul","8":"Ogo","9":"Sep","10":"Okt","11":"Nov","12":"Dis"}}}});
Globalize.a1342965785 = dateToPartsFormatterFn({"1":Globalize("ms-MY").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM","timeSeparator":":","months":{"M":{"4":{"1":"Januari","2":"Februari","3":"Mac","4":"April","5":"Mei","6":"Jun","7":"Julai","8":"Ogos","9":"September","10":"Oktober","11":"November","12":"Disember"}}}});
Globalize.a739287484 = dateToPartsFormatterFn({"1":Globalize("ms-MY").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"Januari","2":"Februari","3":"Mac","4":"April","5":"Mei","6":"Jun","7":"Julai","8":"Ogos","9":"September","10":"Oktober","11":"November","12":"Disember"}}}});
Globalize.a716524004 = dateToPartsFormatterFn({"1":Globalize("ms-MY").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"Januari","2":"Februari","3":"Mac","4":"April","5":"Mei","6":"Jun","7":"Julai","8":"Ogos","9":"September","10":"Oktober","11":"November","12":"Disember"}}}});
Globalize.a717209197 = dateToPartsFormatterFn({"1":Globalize("ms-MY").numberFormatter({"raw":"0"})}, {"pattern":"d MMM y","timeSeparator":":","months":{"M":{"3":{"1":"Jan","2":"Feb","3":"Mac","4":"Apr","5":"Mei","6":"Jun","7":"Jul","8":"Ogo","9":"Sep","10":"Okt","11":"Nov","12":"Dis"}}}});
Globalize.b1176504144 = dateToPartsFormatterFn({"1":Globalize("ms-MY").numberFormatter({"raw":"0"})}, {"pattern":"EEEE, d MMM","timeSeparator":":","days":{"E":{"4":{"sun":"Ahad","mon":"Isnin","tue":"Selasa","wed":"Rabu","thu":"Khamis","fri":"Jumaat","sat":"Sabtu"}}},"months":{"M":{"3":{"1":"Jan","2":"Feb","3":"Mac","4":"Apr","5":"Mei","6":"Jun","7":"Jul","8":"Ogo","9":"Sep","10":"Okt","11":"Nov","12":"Dis"}}}});
Globalize.a1335577617 = dateToPartsFormatterFn({"1":Globalize("ms-MY").numberFormatter({"raw":"0"})}, {"pattern":"E, d MMM","timeSeparator":":","days":{"E":{"1":{"sun":"Ahd","mon":"Isn","tue":"Sel","wed":"Rab","thu":"Kha","fri":"Jum","sat":"Sab"}}},"months":{"M":{"3":{"1":"Jan","2":"Feb","3":"Mac","4":"Apr","5":"Mei","6":"Jun","7":"Jul","8":"Ogo","9":"Sep","10":"Okt","11":"Nov","12":"Dis"}}}});
Globalize.a2034848661 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.a920302293 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a1890209896 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.a767755938 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.a974443317 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.a343913066 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.b1522801963 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.a1028584341 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.a1558078613 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.a1648638504 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.a256023349 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b594791510 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.a950613653 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.b302631787 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b1721474965 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"raw":"d"}));
Globalize.b1357025592 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.b1606405383 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.a1721679536 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b405488123 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.a1095237755 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.a1095922948 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.b1794234695 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.a1714291368 = dateFormatterFn(Globalize("ms-MY").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.b646056892 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.b1760603260 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.a1100828887 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b21625071 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.b1706462236 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.b445467943 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a91259780 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.b1652321212 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.b1122826940 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a859257495 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.a1870085092 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a1211343259 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^A/],["mon",/^I/],["tue",/^S/],["wed",/^R/],["thu",/^K/],["fri",/^J/],["sat",/^S/]]});
Globalize.a39044740 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["tue",/^Selasa/],["thu",/^Khamis/],["fri",/^Jumaat/],["mon",/^Isnin/],["sat",/^Sabtu/],["sun",/^Ahad/],["wed",/^Rabu/]]});
Globalize.b1214200700 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["2",/^Februari/],["11",/^November/],["12",/^Disember/],["1",/^Januari/],["10",/^Oktober/],["4",/^April/],["7",/^Julai/],["8",/^Ogos/],["3",/^Mac/],["5",/^Mei/],["6",/^Jun/]]});
Globalize.a1015705308 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d","digitsRe":/\d/});
Globalize.b1201422601 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b307412886 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^Jan/],["2",/^Feb/],["3",/^Mac/],["4",/^Apr/],["5",/^Mei/],["6",/^Jun/],["7",/^Jul/],["8",/^Ogo/],["9",/^Sep/],["10",/^Okt/],["11",/^Nov/],["12",/^Dis/]]});
Globalize.b959226017 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["2",/^Februari/],["11",/^November/],["12",/^Disember/],["1",/^Januari/],["10",/^Oktober/],["4",/^April/],["7",/^Julai/],["8",/^Ogos/],["3",/^Mac/],["5",/^Mei/],["6",/^Jun/]]});
Globalize.b1909181642 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["2",/^Februari/],["11",/^November/],["12",/^Disember/],["1",/^Januari/],["10",/^Oktober/],["4",/^April/],["7",/^Julai/],["8",/^Ogos/],["3",/^Mac/],["5",/^Mei/],["6",/^Jun/]]});
Globalize.b1585667798 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["2",/^Februari/],["11",/^November/],["12",/^Disember/],["1",/^Januari/],["10",/^Oktober/],["4",/^April/],["7",/^Julai/],["8",/^Ogos/],["3",/^Mac/],["5",/^Mei/],["6",/^Jun/]]});
Globalize.b1584982605 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^Jan/],["2",/^Feb/],["3",/^Mac/],["4",/^Apr/],["5",/^Mei/],["6",/^Jun/],["7",/^Jul/],["8",/^Ogo/],["9",/^Sep/],["10",/^Okt/],["11",/^Nov/],["12",/^Dis/]]});
Globalize.a560272298 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"EEEE, d MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["tue",/^Selasa/],["thu",/^Khamis/],["fri",/^Jumaat/],["mon",/^Isnin/],["sat",/^Sabtu/],["sun",/^Ahad/],["wed",/^Rabu/]],"gregorian/months/format/abbreviated":[["1",/^Jan/],["2",/^Feb/],["3",/^Mac/],["4",/^Apr/],["5",/^Mei/],["6",/^Jun/],["7",/^Jul/],["8",/^Ogo/],["9",/^Sep/],["10",/^Okt/],["11",/^Nov/],["12",/^Dis/]]});
Globalize.b966614185 = dateParserFn(Globalize("ms-MY").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"E, d MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^Ahd/],["mon",/^Isn/],["tue",/^Sel/],["wed",/^Rab/],["thu",/^Kha/],["fri",/^Jum/],["sat",/^Sab/]],"gregorian/months/format/abbreviated":[["1",/^Jan/],["2",/^Feb/],["3",/^Mac/],["4",/^Apr/],["5",/^Mei/],["6",/^Jun/],["7",/^Jul/],["8",/^Ogo/],["9",/^Sep/],["10",/^Okt/],["11",/^Nov/],["12",/^Dis/]]});
module.exports = Globalize;
